// extracted by mini-css-extract-plugin
module.exports = {"labels":"VehicleSpecLabels_labels__VyR15","eu24Labels":"VehicleSpecLabels_eu24Labels__xR2ue"};